import { faMinus } from "@fortawesome/pro-light-svg-icons/faMinus";
import { faPlus } from "@fortawesome/pro-light-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import style from "./style";

export default function NumberInput(props)
{
  const [lastValue, setLastValue] = useState(props.value);
  const [internalValue, setInternalValue] = useState(null);
  const [hasFocus, setFocus] = useState(false);
  const inputRef = useRef();

  const getValue = () =>
  {
    if(internalValue !== undefined && internalValue !== null)
      return internalValue;
    return props.value;
  }

  const decrease = e =>
  {
    if(e.shiftKey)
      setValue(getValue() - 10);
    else
      setValue(getValue() - 1);
  }

  const increase = e =>
  {
    if(e.shiftKey)
      setValue(getValue() + 10);
    else
      setValue(getValue() + 1);
  }

  const setValue = (value, forceNumber) =>
  {
    const currentValue = lastValue || getValue();
    const nextValue = parseValue(value, forceNumber);

    if(nextValue !== currentValue)
    {
      setLastValue(nextValue);
      props.onChange(nextValue, currentValue);
    }

    setInternalValue(null);
  }

  const setKeyValue = value =>
  {
    setInternalValue(parseValue(value));
  }

  const parseValue = (input, forceNumber) =>
  {
    let value = parseInt(input);
    if(isNaN(value))
    {
      if(forceNumber)
        return 1;
      else
        return ""; // React does not like NaN, just return an empty string here to make the field empty
    }
    else if(value <= props.min)
      return props.min;
    else if (value >= props.max)
      return props.max;
    else
      return value;
  }

  const onKey = e =>
  {
    switch(e.key.toLowerCase())
    {
      case "arrowup":
        e.preventDefault();
        if(e.shiftKey)
          setKeyValue(getValue() + 10);
        else
          setKeyValue(getValue() + 1);
      break;
      case "arrowdown":
        e.preventDefault();
        if(e.shiftKey)
          setKeyValue(getValue() - 10);
        else
          setKeyValue(getValue() - 1);
      break;
      case "enter":
        setValue(internalValue);
      break;
    }
  }

  const giveFocus = () => setFocus(true);
  const takeFocus = () => setFocus(false);

  useEffect(() =>
  {
    const currentInput = inputRef.current;
    if(currentInput)
    {
      currentInput.addEventListener("focus", giveFocus);
      currentInput.addEventListener("blur", takeFocus);
    }

    return () =>
    {
      if(currentInput)
      {
        currentInput.removeEventListener("focus", giveFocus);
        currentInput.removeEventListener("blur", takeFocus);
      }
    }
  }, [inputRef.current]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={["ui-numberinput", hasFocus ? "active": ""].join(" ")}>
      <div className="min" onClick={decrease}>
        <FontAwesomeIcon icon={faMinus} />
      </div>
      <input
        ref={inputRef}
        type="text"
        value={getValue()}
        onKeyDown={onKey}
        onChange={e => setKeyValue(e.target.value)}
        onBlur={e => setValue(e.target.value, true)}
      />
      <div className="max" onClick={increase}>
        <FontAwesomeIcon icon={faPlus} />
      </div>
      <style jsx>{style}</style>
    </div>
  );
}

NumberInput.defaultProps = {
  min: 0,
  max: Infinity,
  value: 0
}